module.exports = __webpack_public_path__ + "static/media/template-black-5230.7ee9f947.png";